import { render, staticRenderFns } from "./Rdp.vue?vue&type=template&id=12ddc9db&scoped=true&"
import script from "./Rdp.vue?vue&type=script&lang=js&"
export * from "./Rdp.vue?vue&type=script&lang=js&"
import style0 from "./Rdp.vue?vue&type=style&index=0&id=12ddc9db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ddc9db",
  null
  
)

export default component.exports